/**
 * Module dependencies.
 */

import { Button } from '@mui/material';
import { color } from 'styles/utils/colors';
import styled from '@emotion/styled';

/**
 * Export `MenuItemWrapper` styled component.
 */

export const MenuItemWrapper = styled(Button)`
  color: ${color('white')};
  padding: 12px 16px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 16px;
  letter-spacing: 1px;

  @media (max-width: 1200px) {
    font-size: 15px;
    padding: 10px 14px;
  }

  @media (max-width: 992px) {
    font-size: 13px;
    padding: 6px 10px;
  }

  @media (max-width: 576px) {
    font-size: 12px;
    padding: 5px 8px;
  }
`;
